import { css } from '@emotion/react';

import { rem } from '../utilities/style';

// eslint-disable-next-line import/prefer-default-export
export const shadow = css`
  box-shadow: 0 ${rem(2)} ${rem(8)} rgba(0, 0, 0, 0.08),
              0 ${rem(8)} ${rem(40)} rgba(0, 0, 0, 0.08);
`;
